module.exports = __webpack_public_path__ + "static/media/ar.e9b1f3cf.svg";